import { ApiConfig } from "./apiConfig";

export const get_expense_report = async (data) => {
  try {
    const response = await ApiConfig.post(`expenseReport`, data);
    return response;
  } catch (error) {
    throw error;
  }
};


export const get_expense_profit_report = async (data) => {
  try {
    const response = await ApiConfig.post(`expenseProfitReport`, data);
    return response;
  } catch (error) {
    throw error;
  }
};
